<template>
<el-collapse class="dashboard-collapse">
  <el-collapse-item name="1">
    <template slot="title">
    Inserir ícones por tags
    </template>
    <div class="row">
      <div class="col-xs-12">
        <InputRadioIconRefrigeratoMap v-model="icon"/>
      </div>
    </div>
    <dashboard-form-filters
      @filter="handleSave"
      :showTimeRange="false"
      buttom-label="Aplicar"
    />
  </el-collapse-item>
</el-collapse>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import swal from 'sweetalert2'
import DashboardFormFilters from '../Filters/DashboardFormFilters'
import InputRadioIconRefrigeratoMap from './InputRadioIconRefrigeratoMap'
import {defineWhereObject} from '../../../services/DashboardCounter'

export default {
  name: 'FormIconTags',
  components: {
    DashboardFormFilters,
    InputRadioIconRefrigeratoMap
  },
  data () {
    return {
      icon: 'troca_geladeira_0.png'
    }
  },
  computed: {
    ...mapGetters('eventsSpecifications', ['imagesMap']),
    ...mapGetters('tags', {tagsSelected: 'selecteds'}),
    ...mapGetters('categories', ['categories'])
  },
  methods: {
    ...mapActions('eventsSpecifications', {updateManySpecifications: 'updateMany', fetchSpecifications: 'fetchAll'}),
    ...mapActions('categories', {fetchCategories: 'fetchAll'}),
    handleSave (event) {
      if (Object.keys(this.tagsSelected).length !== 0 && Object.keys(this.tagsSelected).length < this.categories.length) {
        return this.notifyIncorrectCategorieSize()
      }
      return this.notifyProcess()
    },
    notifyProcess () {
      swal({
        title: 'Confirmação',
        html: Object.keys(this.tagsSelected).length === 0 ? `O icone <img src="${this.imagesMap.basePath}${this.icon}"> será adicionado a todos os eventos.` : `O icone <img src="${this.imagesMap.basePath}${this.icon}"> será adicionado a todos os eventos marcados pelas tags.`,
        type: 'info',
        confirmButtonText: 'Iniciar',
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.exec()
          return 'ok'
        }
      }).then(() => {
        setTimeout(function () {
          location.reload()
        }, 3000)

        swal({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        })
      })
    },
    async exec () {
      this.getEventsSpecifications()
      .then((specifications) => {
        return this.updateManySpecifications(
          specifications.map(spec => {
            spec.refrigeratorIcon = this.icon
            spec.tagsIds = Object.values(spec.tags)
            return spec
          })
        )
      })
    },
    getEventsSpecifications () {
      if (Object.keys(this.tagsSelected).length === 0) {
        return this.fetchSpecifications({limit: 99999})
      }

      const whereTags = defineWhereObject(undefined, this.tagsSelected, 'tagsIds')
      return this.fetchSpecifications({
        where: {
          '$and': whereTags['$and']
        },
        limit: 99999
      })
    },
    notifyIncorrectCategorieSize () {
      return swal('Quantidade incorreta de tags', 'Escolha pelo menos 1 tag por categoria', 'error')
    }
  },
  mounted () {
    if (this.categories.length === 0) {
      this.fetchCategories({limit: 999})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/EventsSpecifications/FormIconTags.vue